import BlogEmpresarialHome from "../components/empresas/blog/BlogEmpresarialHome";

const BlogEmpresarial = () => (
  <div className="bg-white">
    <BlogEmpresarialHome />
  </div>
);

export default BlogEmpresarial;
